import { SearchParamsUpdate, StaticSearch } from '@atlassian/amkt-addon-discovery';
import ImmutablePropTypes from '@atlassian/react-immutable-proptypes';
import { fromJS } from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ScreenClassRender } from 'react-grid-system';

import { AlgoliaConfig } from '../../../../../../../../records/CommonConfig';
import SearchConfigValidation from '../../../../../../../common/SearchConfigValidation';

import solutionStyles from '../Solution.less';

export default class SolutionAddons extends Component {
  static propTypes = {
    algoliaConfig: PropTypes.instanceOf(AlgoliaConfig).isRequired,
    applyOverrides: PropTypes.instanceOf(SearchParamsUpdate).isRequired,
    environment: PropTypes.string.isRequired,
    filters: ImmutablePropTypes.map.isRequired,
    hidePagination: PropTypes.bool,
    hitContext: PropTypes.object.isRequired,
    hitSize: PropTypes.string,
    maxLength: PropTypes.number,
    sortHits: PropTypes.func,
    transitions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div>
        {/* @ts-expect-error [MC-2850] - TS2339 - Property 'algoliaConfig' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'. */}
        <SearchConfigValidation config={this.props.algoliaConfig}>
          {() => (
            <div className={solutionStyles.solutionContainer}>
              <ScreenClassRender render={this.renderStaticSearch}>
                <span />
              </ScreenClassRender>
            </div>
          )}
        </SearchConfigValidation>
      </div>
    );
  }

  renderStaticSearch = (sc: any) => (
    <StaticSearch
      // to convert it to a Map, which amkt-addon-discovery expects
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      algoliaConfig={fromJS(this.props.algoliaConfig.toJS())}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      applyOverrides={this.props.applyOverrides}
      debug={process.env.NODE_ENV !== 'production'}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      environment={this.props.environment}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      filters={this.props.filters}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      hidePagination={this.props.hidePagination}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      hitContext={this.props.hitContext}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      hitSize={this.props.hitSize}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      maxLength={this.props.maxLength}
      screenClass={sc}
      // @ts-expect-error [MC-2850] - TS2532 - Object is possibly 'undefined'.
      sortHits={this.props.sortHits}
      // @ts-expect-error [MC-2850] - TS2322 - Type '{ algoliaConfig: any; applyOverrides: any; debug: boolean; environment: any; filters: any; hidePagination: any; hitContext: any; hitSize: any; maxLength: any; screenClass: any; sortHits: any; transitions: any; }' is not assignable to type 'IntrinsicAttributes & Pick<InferProps<{ algoliaConfig: any; algoliaClient: any; applyOverrides: Requireable<SearchParamsUpdate>; ... 11 more ...; sortHits: Requireable<...>; }>, "algoliaConfig" | ... 9 more ... | "sortHits"> & Partial<...> & Partial<...>'. | TS2532 - Object is possibly 'undefined'.
      transitions={this.props.transitions}
    />
  );
}
